import { FavType } from '../Api/firebase/AuthData'
export type FavoritesProps = {
  item: string
  favType: FavType
  favorites: string[] | []
  team?: string
}

export type TeamFavoriteProps = {
  team: string
}
/**
 * Check if user has favorited item (player, team, topic, etc.)
 */
export const checkFavorite = (item: string, favorites: string[]) => {
  return favorites.includes(item)
}